<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list @form="dialog = true" @clear="$refs.form.clear()" />
        <form-manager ref="form" :dialog="dialog" @close="dialog = false" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormManager from './FormManager'
import List from './List'

export default {
  name: 'TypeEvents',
  components: {
    List,
    FormManager,
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.$store.dispatch('typeEvents/resetState')
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      setStatus: 'events/setStatus',
      fetchTypeEvents: 'typeEvents/fetchList',
    }),
    async initData() {
      await Promise.all([this.fetchTypeEvents({ limit: 0 })])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
  },
}
</script>
